import React from 'react';
import HeroSection from '../components/HeroSection';
import ServiceCatalog from '../components/ServiceCatalog';
import HowItWorks from '../components/HowItWorks';

const HomePage = ({ setShowGetStartedModal }) => {
  return (
    <>
      <HeroSection onGetStarted={() => setShowGetStartedModal(true)} />
      <ServiceCatalog />
      <HowItWorks onGetStarted={() => setShowGetStartedModal(true)} />
    </>
  );
};

export default HomePage;
